import { useState } from "react";
import { useLocation } from 'react-router-dom';
import { ApiResponse } from 'apisauce';
import { makeStyles, Theme } from '@material-ui/core/styles';
import {Paper, Typography, Box, Button } from '@material-ui/core';
import Spinner, { SpinnerColor, SpinnerSize } from 'shared-components/Spinner';
import CopyRight from 'shared-components/CopyRight';
import api from 'api';

import colors from 'colors';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 60,
        backgroundColor: colors.lightGrey,
    },
    innerContainer: {
        padding: '32px 48px',
        width: 'calc(100% - 32px)',
        maxWidth: 814,
        [theme.breakpoints.down('sm')]: {
            padding: '28px',
        },
    },
    link: {
        color: colors.blue,
        '&:hover': {
            color: colors.mediumBlue,
        },
    },
}));

const Unsubscribe = () => {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [isUnsubscribed, setIsUnsubscribed] = useState<boolean|null>(null)

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const token = query.get('token');

    const supportEmail = "support@personalise.gov.sg"

    if (isLoading) {
        return <Spinner color={SpinnerColor.BLUE} size={SpinnerSize.LARGE} isCenter={true} />;
    }

    if (!token) {
        return (
            <div className={classes.container}>
                <CopyRight />
            </div>
        );
    }

    return (
        <div className={classes.container}>
            <Paper className={classes.innerContainer} elevation={1}>
                { isUnsubscribed === null && (
                    <Box textAlign="left">
                        <Typography variant="body1" style={{ paddingBottom: 16 }}>
                            You will be removed from this subscriber list and will no longer receive any emails sent to
                            this list.
                        </Typography>
                        <Typography variant="body1">
                            <Button className={classes.link} onClick={
                                () => {
                                    setIsLoading(true)
                                    api.unsubscribe({ token })
                                        .then((response: ApiResponse<any>) => {
                                            if (response.ok) {
                                                setIsUnsubscribed(true)
                                            } else {
                                                setIsUnsubscribed(false)
                                            }
                                        })
                                        .finally(() => {
                                            setIsLoading(false)
                                        });
                                }
                            }>
                                Click here to unsubscribe
                            </Button>
                        </Typography>
                    </Box>
                )}
                { isUnsubscribed === true  && (
                    <Typography variant="h1">
                        Unsubscribed successfully
                    </Typography>
                )}
                { isUnsubscribed === false && (
                    <Typography variant="body1">
                        There was an error unsubscribing you from the mailing list, please contact
                        <address style={{ display: 'inline', margin: '0 0.3rem' }}>
                            <a style={{ color: colors.blue }} href={ `mailto:${ supportEmail }` }> { supportEmail } </a>
                        </address>
                        for more information.
                    </Typography>
                )}
            </Paper>
            <CopyRight />
        </div>
    );
};

export default Unsubscribe;
